import { clsx } from 'clsx';
import { FC, MouseEventHandler } from 'react';
import { Icon, IconType } from 'atoms/Icon';
import { IWishlistIconView } from './types';
import styles from './styles.module.css';

export const WishlistIconView: FC<IWishlistIconView> = ({
  className,
  variantId,
  addToWishlist,
  removeFromWishlist,
  wishlist,
  productName,
  pageType,
}) => {
  const activeItem = wishlist?.items.find(
    (item) => item.variantId === variantId,
  );

  const handleClick: MouseEventHandler<HTMLSpanElement> = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (activeItem?.key) {
      removeFromWishlist?.(activeItem.key, { name: productName }, pageType);
    } else {
      variantId && addToWishlist?.(variantId, { name: productName }, pageType);
    }
  };

  return (
    <Icon
      type={!!activeItem ? IconType.heart : IconType.heartbordered}
      className={clsx(styles.root, className)}
      onClick={handleClick}
    />
  );
};
